import { Box, Heading, useToast, VStack } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  dashboardRoutePadding,
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { CustomersTable } from 'valleyBank/domains/Customers/ui/overview/CustomersTable';
import 'source/borrower/borrower.scss';

export const CustomersOverviewRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();

  let routeLevelError = false;
  return (
    <Box padding={dashboardRoutePadding}>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load settings page`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/');
          }
        }}
      >
        <VStack spacing="32px" alignItems="flex-start">
          <Heading as="h2" mb="60px">
            Customers
          </Heading>
          <CustomersTable />
        </VStack>
      </Sentry.ErrorBoundary>
    </Box>
  );
};
